import React from "react"

const BgVideosection = ({ videoSrcURL, videoTitle, ...props }) => (
    <video style={{objectFit: 'cover', width: '100%', minHeight: '710px'}} playsInline autoPlay={true} muted loop>
      <source src={videoSrcURL} type="video/mp4" />
    </video>
)
export default BgVideosection